import { FormattedMessage } from 'react-intl';

import messages from './ProductType.messages';
import { IwDynamicFormattedMessage } from '../../../iwDynamicFormattedMessage/IwDynamicFormattedMessage';

const ProductType = ({
    productType,
    durationInMonths
}: {
    productType: string;
    durationInMonths?: number;
}) => {
    if (['credit_facility', 'flexi24'].includes(productType)) {
        return (
            <FormattedMessage
                {...messages.longer_credit_facility}
                values={{
                    duration: durationInMonths
                }}
            />
        );
    } else
        return (
            <IwDynamicFormattedMessage
                messages={messages}
                messageKey={`${productType}_label`}
                defaultMessage=""
            />
        );
};

// eslint-disable-next-line import/no-default-export
export default ProductType;
